export function haversine(lat1: number, lng1: number, lat2: number, lng2: number): number {
  const R = 6371000 // Earth's radius in meters
  const φ1 = (lat1 * Math.PI) / 180
  const φ2 = (lat2 * Math.PI) / 180
  const Δφ = ((lat2 - lat1) * Math.PI) / 180
  const Δλ = ((lng2 - lng1) * Math.PI) / 180

  const a =
    Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
    Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2)

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  return R * c
}

export function metersToFeet(meters: number): number {
  return meters * 3.28084
}

export function metersToMiles(meters: number): number {
  return meters * 0.000621371
}

export function isWithinHandoff(lat1: number, lng1: number, lat2: number, lng2: number, thresholdFeet = 20): boolean {
  const meters = haversine(lat1, lng1, lat2, lng2)
  const feet = metersToFeet(meters)
  return feet < thresholdFeet
}
